import React from 'react'
import { useTranslation } from 'react-i18next'
import { b2bMarketLabel } from '../../utils/b2bMarketDisplay'

type TeamSplitCardProps = {
    available: boolean
    byMarket: Array<{ market: string; clientPct: number; fiftyOneTripsPct: number }>
}

export const TeamSplitCard: React.FC<TeamSplitCardProps> = ({ available, byMarket }) => {
    const { t } = useTranslation('dashboard')
    if (!available || byMarket.length === 0) {
        return (
            <div className="bg-white rounded-2xl p-4 border border-dashed border-neutralBlack-300 flex flex-col gap-2 items-start justify-center">
                <span className="text-[11.5px] font-medium tracking-wide uppercase text-neutralBlack-400">{t('metrics.assemblyTitle')}</span>
                <span className="text-sm text-neutralBlack-400">{t('metrics.assemblyComingSoon')}</span>
            </div>
        )
    }

    return (
        <div className="bg-white rounded-2xl p-4 border border-neutralBlack-200 shadow-sm flex flex-col gap-3.5">
            <span className="text-[11.5px] font-medium tracking-wide uppercase text-neutralBlack-500">{t('metrics.assemblyTitle')}</span>
            <div className="grid grid-cols-2 gap-x-2.5 gap-y-3.5">
                {byMarket.map((entry) => (
                    <div key={entry.market} className="flex items-center gap-2.5 min-w-0">
                        <span
                            className="relative w-[38px] h-[38px] flex-none rounded-full"
                            style={{ background: `conic-gradient(#04A3B3 0deg ${entry.clientPct * 3.6}deg, #E8A200 ${entry.clientPct * 3.6}deg 360deg)` }}
                        >
                            <span className="absolute inset-[6px] rounded-full bg-white" />
                        </span>
                        <span className="min-w-0 flex flex-col gap-px">
                            <span className="text-xs leading-tight text-neutralBlack-600">{b2bMarketLabel(entry.market)}</span>
                            <span className="text-[13px] text-neutralBlack-900">
                                <span className="font-semibold">{entry.clientPct}%</span> · {entry.fiftyOneTripsPct}%
                            </span>
                        </span>
                    </div>
                ))}
            </div>
            <div className="flex items-center gap-3.5 flex-wrap">
                <span className="inline-flex items-center gap-1.5 text-xs text-neutralBlack-800">
                    <span className="w-[9px] h-[9px] rounded-[3px]" style={{ background: '#04A3B3' }} />
                    {t('metrics.assemblyClient')}
                </span>
                <span className="inline-flex items-center gap-1.5 text-xs text-neutralBlack-800">
                    <span className="w-[9px] h-[9px] rounded-[3px]" style={{ background: '#E8A200' }} />
                    {t('metrics.assembly51trips')}
                </span>
            </div>
        </div>
    )
}
